import Avatar from "@/components/base/Avatar";
import { validColor } from "@/lib/color";
import type { OrgGroup } from "@/lib/types";
import OrgName from "./OrgName";

// 1단: 회장 — 가운데 큰 상자 하나
export default function OrgHeadBox({ group }: { group: OrgGroup }) {
  const member = group.members?.[0];
  const bg = validColor(group.color) ?? "oklch(var(--primary-700))";

  return (
    <div className="org-card mx-auto w-full max-w-sm overflow-hidden rounded-xl border border-background-200">
      <div
        className="px-5 py-3.5 text-center font-heading text-base font-bold text-white"
        style={{ backgroundColor: bg }}
      >
        {group.name}
      </div>
      {member && (
        <div className="flex items-center justify-center gap-3 bg-background-50 px-4 py-6">
          <Avatar name={member.name} photo={member.photo} color={group.color} size={48} />
          <OrgName
            member={member}
            className="font-heading text-lg font-bold text-foreground-950"
          />
        </div>
      )}
    </div>
  );
}